import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetSelfServiceSubscriptionsFrequencyParams } from '../../../spacesPlatform/utils/actionParams';

export class SetSelfServiceSubscriptionsFrequencyRequest extends Request<ISetSelfServiceSubscriptionsFrequencyParams, IEmptyResult> {
    constructor(params: ISetSelfServiceSubscriptionsFrequencyParams) {
        super('setSubscriptionsSelfServiceSchedule', params);
    }
}
